if (!window.__lunchboxJsLoaded) {
window.__lunchboxJsLoaded = true;
/* =============================================
   PERFORMANCE-OPTIMIZED JAVASCRIPT
   All mobile-heavy operations are guarded by
   isMobile checks or disabled for touch devices
   ============================================= */
var isMobile = window.innerWidth <= 768;

// ── Accordion Toggle (fast: no layout thrash) ──────────────────────────────
function toggleAccordion(header) {
  var content = header.nextElementSibling;
  var isActive = content.classList.contains('active');
  var parent = header.parentElement.parentElement;
  parent.querySelectorAll('.accordion-content').forEach(function(c) { c.classList.remove('active'); });
  parent.querySelectorAll('.accordion-header').forEach(function(h) { h.classList.remove('active'); });
  if (!isActive) {
    content.classList.add('active');
    header.classList.add('active');
  }
}

// ── Reels Carousel Scroll ──────────────────────────────────────────────────
function reelsScroll(btn, dir) {
  var track = btn.parentElement.querySelector('.reels-track');
  if (track) track.scrollBy({ left: dir * 260, behavior: 'smooth' });
}

// ── Recipe Gallery Scroll ──────────────────────────────────────────────────
function rgScroll(btn, dir) {
  var track = btn.parentElement.querySelector('.rg-track');
  if (track) track.scrollBy({ left: dir * 230, behavior: 'smooth' });
}

// ── Social Proof Carousel Scroll ───────────────────────────────────────────
function spScroll(btn, dir) {
  var track = btn.parentElement.querySelector('.sp-track');
  if (track) track.scrollBy({ left: dir * 240, behavior: 'smooth' });
}

// ── Book Section Toggle ────────────────────────────────────────────────────
function toggleSection(header) {
  var content = header.nextElementSibling;
  var icon = header.querySelector('.section-icon');
  var isOpen = content.style.display === 'block';
  content.style.display = isOpen ? 'none' : 'block';
  if (icon) icon.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(90deg)';
}

// ── Ripple (desktop only — skip costly DOM ops on mobile taps) ─────────────
function createRipple(event) {
  if (isMobile) return; // Skip on mobile — touch-action:manipulation already handles feedback
  var button = event.currentTarget;
  var ripple = document.createElement('span');
  var rect = button.getBoundingClientRect();
  var size = Math.max(rect.width, rect.height);
  ripple.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (event.clientX - rect.left - size/2) + 'px;top:' + (event.clientY - rect.top - size/2) + 'px;';
  ripple.classList.add('ripple');
  button.appendChild(ripple);
  setTimeout(function() { ripple.remove(); }, 600);
}

// ── Add to Cart (Shopify) ──────────────────────────────────────────────────
function addToCart(variantId, event) {
  if (event && !isMobile) createRipple(event);
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
  .then(response => response.json())
  .then(() => { window.location.href = '/cart'; })
  .catch(error => {
    console.error('Error:', error);
    alert('Error adding to cart. Please try again.');
  });
}

// ── Scroll Reveal (desktop only — mobile skips to save CPU/battery) ────────
if (!isMobile && 'IntersectionObserver' in window) {
  var scrollObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        scrollObserver.unobserve(entry.target); // Stop observing once visible
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('section').forEach(function(sec) {
    sec.classList.add('fade-in');
    scrollObserver.observe(sec);
  });
}

// ── Marquee pause on hover (passive listener, desktop only) ───────────────
if (!isMobile) {
  var marquee = document.querySelector('.marquee');
  if (marquee) {
    marquee.addEventListener('mouseenter', function() { marquee.style.animationPlayState = 'paused'; }, { passive: true });
    marquee.addEventListener('mouseleave', function() { marquee.style.animationPlayState = 'running'; }, { passive: true });
  }
}

// ── Reels: Inline Video Playback ──────────────────────────────────────────
function reelPlay(wrapper) {
  var type      = wrapper.getAttribute('data-video-type') || 'external';
  var thumbLayer = wrapper.querySelector('.reel-thumb-layer');

  if (type === 'shopify') {
    // Play Shopify-hosted video natively
    var vid = wrapper.querySelector('.reel-shopify-video');
    if (!vid) return;
    vid.style.display = 'block';
    vid.controls = true;
    vid.play().catch(function(){});
    if (thumbLayer) thumbLayer.style.display = 'none';

  } else {
    // Inject YouTube / Instagram iframe
    var url = wrapper.getAttribute('data-video');
    if (!url) return;
    var embedUrl = reelBuildEmbed(url);
    if (!embedUrl) return;
    var iframeContainer = wrapper.querySelector('.reel-iframe-container');
    iframeContainer.innerHTML =
      '<iframe src="' + embedUrl + '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; gyroscope" allowfullscreen ' +
      'style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;will-change:transform;"></iframe>';
    iframeContainer.style.display = 'block';
    if (thumbLayer) thumbLayer.style.display = 'none';
  }
}

function reelBuildEmbed(url) {
  // YouTube: youtube.com/watch?v=ID  |  youtu.be/ID  |  youtube.com/shorts/ID  |  youtube.com/reel/ID
  var ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|reel\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  if (ytMatch) {
    return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&mute=1&rel=0&playsinline=1&enablejsapi=1&modestbranding=1';
  }
  // Instagram Reel: instagram.com/reel/CODE/
  var igMatch = url.match(/instagram\.com\/(?:reel|p)\/([A-Za-z0-9_-]+)/);
  if (igMatch) {
    return 'https://www.instagram.com/p/' + igMatch[1] + '/embed/';
  }
  return null;
}

// ── Reels: Auto YouTube Thumbnails ────────────────────────────────────────
function reelInitAutoThumbs() {
  document.querySelectorAll('img.reel-auto-thumb').forEach(function(img) {
    var url = img.getAttribute('data-yt-auto');
    if (!url) return;
    var ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|reel\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (!ytMatch) return;
    var vid = ytMatch[1];
    var fallback = img.parentElement.querySelector('.reel-thumb-fallback');
    // Try maxresdefault first, fall back to hqdefault
    img.onload = function() {
      if (img.naturalWidth > 1) {
        if (fallback) fallback.style.display = 'none';
      }
    };
    img.onerror = function() {
      img.src = 'https://i.ytimg.com/vi/' + vid + '/hqdefault.jpg';
    };
    img.src = 'https://i.ytimg.com/vi/' + vid + '/maxresdefault.jpg';
  });
}

// ── Reels: Autoplay on Scroll into View ───────────────────────────────────
function reelInitAutoplay() {
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var wrapper = entry.target;
        if (wrapper.getAttribute('data-autoplay') === 'true') {
          reelPlay(wrapper);
          observer.unobserve(wrapper); // Only autoplay once
        }
      }
    });
  }, { threshold: 0.75 });

  document.querySelectorAll('.reel-media-wrapper').forEach(function(w) {
    if (w.getAttribute('data-autoplay') === 'true') observer.observe(w);
  });
}

// ── Init: Run non-critical work after browser is idle ─────────────────────
document.addEventListener('DOMContentLoaded', function() {
  var idle = window.requestIdleCallback || function(cb) { setTimeout(cb, 200); };
  idle(function() {
    reelInitAutoThumbs();
    reelInitAutoplay();
  });
});
}
